import { useContent } from '@parcel2go/npm-p2g-app';
import { useMemo } from 'react';

const useContentString = (contentKey: string) => {
  const { state } = useContent();

  const s = useMemo(
    () =>
      state?.data
        ?.map((entry) => {
          const fields = entry.fields as { name: string; value: unknown };
          if (fields && fields.name === contentKey && fields.value && typeof fields.value === 'string') {
            return fields.value as string;
          }
        })
        .filter(Boolean)
        .join(),
    [state.data, contentKey]
  );

  return s;
};

export default useContentString;
